const postEquipmentServices = {
  toastr: 'Servicio agregado',
  massService: 'Servicio masivo agregado',
  toastrError: 'Tipo de servicio ya registrado',
  toastrError1: 'Ingrese otro nombre'
};

export default postEquipmentServices;
